<template>
  <div class="block min-h-md w-full animate-pulse bg-gray-200" />
</template>
